import { render, staticRenderFns } from "./ImagePlaceholder.vue?vue&type=template&id=3d6c621a&scoped=true"
import script from "./ImagePlaceholder.vue?vue&type=script&lang=js"
export * from "./ImagePlaceholder.vue?vue&type=script&lang=js"
import style0 from "./ImagePlaceholder.vue?vue&type=style&index=0&id=3d6c621a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6c621a",
  null
  
)

export default component.exports